import React from 'react';
import Registry from 'registry';

import {blackListUser, unBlackListUser} from 'reducers/member';
import paths from 'paths';

import {
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    SET_CURRENT_USER
} from 'reducers/currentUser';

import {
    receiveInstantNotification,
    RECEIVE_INSTANT_NOTIFICATION
} from 'reducers/memberNotificationList';

import { localizeUrl } from 'components/ReactRouterDomLocalized';

let sendNotifications = undefined;

const hitagiMiddleware = function hitagiMiddleware(store) {
    return function (next) {
        return function (action) {
            const HITAGI_URL = Registry.get('HITAGI_PM_URL');
            let wss_url = HITAGI_URL.match(/^wss:/) ? HITAGI_URL : Registry.get('PUBLIC_URL').replace(/^https?:/, "wss:") + HITAGI_URL;
            

            switch(action.type) {
                case LOGIN_SUCCESS:
                case SET_CURRENT_USER: {
                    let currentUserUid = action.user.id;
                    store.dispatch({type: "PM_CONNECT_TO_SERVER", url: wss_url, user: action.user});
                    
                    break;
                }
                case LOGOUT_SUCCESS:
                    store.dispatch({type: "PM_DISCONNECT_FROM_SERVER"});
                    break;

                case "PM_UNBLOCK_USER":
                    let action2 = unBlackListUser(action.conversation_uid);
                    store.dispatch(action2);
                    break;

                case "PM_MESSAGE":
                    if (action.message.payload) break;
                    let user = store.getState().pm.conversations[action.conversation_uid].users.recipient;
                    if (action.message.sender_uid != action.conversation_uid) break;
                    let url = paths.memberMessagePmConversationsItem.toPath({uid: user.uid});

                    url = localizeUrl(url);

                    if (url != store.getState().router.location.pathname) {
                        if (sendNotifications == undefined) {
                            sendNotifications = store.getState().currentUser.notification_settings.message.site;
                        }
                        if (sendNotifications) {
                            let image = false;
                            if (action.message.rendered.attachments) {
                                image = action.message.rendered.attachments[0].url;
                            }
                            store.dispatch(receiveInstantNotification({type: "pm_message", data: {date: 0, meta:{text: action.message.rendered.text, image: image, user: user, url: '/membre/pm/conversations/' + user.uid}}}));
                        }
                    } else {
                        if (store.getState().visibility.visibilityState == "visible") {
                            store.dispatch({type: "PM_MARK_READ", conversation_uid: action.conversation_uid});
                        }
                    }
                    break;

                case "PM_OPEN_ATTACHMENT":
                    let conv = store.getState().pm.conversations[action.conversation_uid];
                    let attachmentsList = conv.attachments;
                    let photo = null;

                    for (let i in attachmentsList) {
                        attachmentsList[i].user = conv.users[attachmentsList[i].author_label];

                        if (attachmentsList[i].url == action.attachment.url) {
                            photo = attachmentsList[i];
                        }
                    }
                    let photoList = attachmentsList;

                    if (photo) {
                        store.dispatch({type: "OPEN_PHOTO_LIST", photo:photo, list:photoList});
                        return;
                    }
                    
                    break;

                case "VISIBILITY_STATE_CHANGE":
                    if (action.visibilityState == "visible") {
                        let pm = store.getState().pm;
                        if (pm.status == "connected") {
                            for (let i in pm.conversations) {
                                if (pm.conversations[i].view.maximized) {
                                    store.dispatch({type:"PM_MARK_READ", conversation_uid: pm.conversations[i].user.uid});
                                }
                            }
                        }
                    }
                    break;
                case "SET_MEMBER_NOTIFICATIONSETTINGS_SUCCESS":
                    const settings = JSON.parse(action.data.settings);
                    
                    sendNotifications = settings.message.site;
                    break;
            }
        return next(action);
      };
    };
  };

export default hitagiMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/hitagiMiddleware.js